import { axiosV2 } from 'interceptors/axios';
import { store } from 'redux/store';
import { decryptResponse } from 'utils/token';

type GetPartnerInversion = {
  partnerId: string;
  societyId: string;
};

export const getPartnerInversion = async ({
  partnerId,
  societyId,
}: GetPartnerInversion) => {
  const query = { params: { partnerId, societyId } };

  try {
    const { data } = await axiosV2.get('/partners/inversion', query);

    const decodedData = await decryptResponse(data);

    return decodedData;
  } catch (error) {
    store.dispatchError(error, store.dispatch);
  }
};
